module.exports = __webpack_public_path__ + "static/media/przemiana3_left.28a85bfe.jpeg";